var map = {
	"./client/applications/justopp/assets/static/icons/justoppIcons/3d-scan.svg": 76352,
	"./client/applications/justopp/assets/static/icons/justoppIcons/airplay.svg": 32872,
	"./client/applications/justopp/assets/static/icons/justoppIcons/alarm.svg": 98335,
	"./client/applications/justopp/assets/static/icons/justoppIcons/align-center-alt.svg": 88624,
	"./client/applications/justopp/assets/static/icons/justoppIcons/align-center.svg": 9192,
	"./client/applications/justopp/assets/static/icons/justoppIcons/align-justify-alt.svg": 67489,
	"./client/applications/justopp/assets/static/icons/justoppIcons/align-justify.svg": 66793,
	"./client/applications/justopp/assets/static/icons/justoppIcons/align-left-alt.svg": 34847,
	"./client/applications/justopp/assets/static/icons/justoppIcons/align-left.svg": 97967,
	"./client/applications/justopp/assets/static/icons/justoppIcons/align-right-alt.svg": 87327,
	"./client/applications/justopp/assets/static/icons/justoppIcons/align-right.svg": 43113,
	"./client/applications/justopp/assets/static/icons/justoppIcons/archive.svg": 63198,
	"./client/applications/justopp/assets/static/icons/justoppIcons/arrow-black.svg": 44722,
	"./client/applications/justopp/assets/static/icons/justoppIcons/arrow-down-circle.svg": 69083,
	"./client/applications/justopp/assets/static/icons/justoppIcons/arrow-down-small.svg": 4592,
	"./client/applications/justopp/assets/static/icons/justoppIcons/arrow-down-square.svg": 94133,
	"./client/applications/justopp/assets/static/icons/justoppIcons/arrow-down.svg": 53117,
	"./client/applications/justopp/assets/static/icons/justoppIcons/arrow-download-alt.svg": 39018,
	"./client/applications/justopp/assets/static/icons/justoppIcons/arrow-download.svg": 18120,
	"./client/applications/justopp/assets/static/icons/justoppIcons/arrow-left-circle.svg": 23235,
	"./client/applications/justopp/assets/static/icons/justoppIcons/arrow-left-down.svg": 30115,
	"./client/applications/justopp/assets/static/icons/justoppIcons/arrow-left-small.svg": 30306,
	"./client/applications/justopp/assets/static/icons/justoppIcons/arrow-left-square.svg": 29029,
	"./client/applications/justopp/assets/static/icons/justoppIcons/arrow-left-up.svg": 46163,
	"./client/applications/justopp/assets/static/icons/justoppIcons/arrow-left.svg": 1643,
	"./client/applications/justopp/assets/static/icons/justoppIcons/arrow-login-left-alt.svg": 88805,
	"./client/applications/justopp/assets/static/icons/justoppIcons/arrow-login-left.svg": 96996,
	"./client/applications/justopp/assets/static/icons/justoppIcons/arrow-login-right-alt.svg": 81670,
	"./client/applications/justopp/assets/static/icons/justoppIcons/arrow-login-right.svg": 27371,
	"./client/applications/justopp/assets/static/icons/justoppIcons/arrow-logout-left-alt.svg": 9348,
	"./client/applications/justopp/assets/static/icons/justoppIcons/arrow-logout-left.svg": 77390,
	"./client/applications/justopp/assets/static/icons/justoppIcons/arrow-logout-right-alt.svg": 37849,
	"./client/applications/justopp/assets/static/icons/justoppIcons/arrow-logout-right.svg": 31671,
	"./client/applications/justopp/assets/static/icons/justoppIcons/arrow-orange.svg": 42233,
	"./client/applications/justopp/assets/static/icons/justoppIcons/arrow-right-circle.svg": 93736,
	"./client/applications/justopp/assets/static/icons/justoppIcons/arrow-right-down.svg": 86184,
	"./client/applications/justopp/assets/static/icons/justoppIcons/arrow-right-small.svg": 63213,
	"./client/applications/justopp/assets/static/icons/justoppIcons/arrow-right-square.svg": 15454,
	"./client/applications/justopp/assets/static/icons/justoppIcons/arrow-right-up.svg": 67770,
	"./client/applications/justopp/assets/static/icons/justoppIcons/arrow-right.svg": 94114,
	"./client/applications/justopp/assets/static/icons/justoppIcons/arrow-up-circle.svg": 34970,
	"./client/applications/justopp/assets/static/icons/justoppIcons/arrow-up-small.svg": 79005,
	"./client/applications/justopp/assets/static/icons/justoppIcons/arrow-up-square.svg": 10723,
	"./client/applications/justopp/assets/static/icons/justoppIcons/arrow-up.svg": 78098,
	"./client/applications/justopp/assets/static/icons/justoppIcons/arrow-upload-alt.svg": 26585,
	"./client/applications/justopp/assets/static/icons/justoppIcons/arrow-upload.svg": 54067,
	"./client/applications/justopp/assets/static/icons/justoppIcons/arrow-white.svg": 66109,
	"./client/applications/justopp/assets/static/icons/justoppIcons/arrows-sort.svg": 72621,
	"./client/applications/justopp/assets/static/icons/justoppIcons/article.svg": 37818,
	"./client/applications/justopp/assets/static/icons/justoppIcons/bag-alt.svg": 2444,
	"./client/applications/justopp/assets/static/icons/justoppIcons/bag-plus.svg": 96678,
	"./client/applications/justopp/assets/static/icons/justoppIcons/bag.svg": 46948,
	"./client/applications/justopp/assets/static/icons/justoppIcons/bar-code.svg": 2402,
	"./client/applications/justopp/assets/static/icons/justoppIcons/basket.svg": 35278,
	"./client/applications/justopp/assets/static/icons/justoppIcons/battery-charging.svg": 73914,
	"./client/applications/justopp/assets/static/icons/justoppIcons/battery-empty.svg": 34514,
	"./client/applications/justopp/assets/static/icons/justoppIcons/battery-full.svg": 53693,
	"./client/applications/justopp/assets/static/icons/justoppIcons/battery-half.svg": 55649,
	"./client/applications/justopp/assets/static/icons/justoppIcons/bell.svg": 59412,
	"./client/applications/justopp/assets/static/icons/justoppIcons/binder.svg": 18625,
	"./client/applications/justopp/assets/static/icons/justoppIcons/bluetooth.svg": 20506,
	"./client/applications/justopp/assets/static/icons/justoppIcons/book.svg": 4966,
	"./client/applications/justopp/assets/static/icons/justoppIcons/bookmark.svg": 97464,
	"./client/applications/justopp/assets/static/icons/justoppIcons/brands-codepen.svg": 87053,
	"./client/applications/justopp/assets/static/icons/justoppIcons/brands-codesandbox.svg": 62871,
	"./client/applications/justopp/assets/static/icons/justoppIcons/brands-dribbble.svg": 85611,
	"./client/applications/justopp/assets/static/icons/justoppIcons/brands-dropbox.svg": 79417,
	"./client/applications/justopp/assets/static/icons/justoppIcons/brands-facebook.svg": 64878,
	"./client/applications/justopp/assets/static/icons/justoppIcons/brands-figma.svg": 41230,
	"./client/applications/justopp/assets/static/icons/justoppIcons/brands-github.svg": 24630,
	"./client/applications/justopp/assets/static/icons/justoppIcons/brands-google.svg": 14120,
	"./client/applications/justopp/assets/static/icons/justoppIcons/brands-instagram.svg": 75057,
	"./client/applications/justopp/assets/static/icons/justoppIcons/brands-linkedin.svg": 44808,
	"./client/applications/justopp/assets/static/icons/justoppIcons/brands-paypal.svg": 20349,
	"./client/applications/justopp/assets/static/icons/justoppIcons/brands-snapchat.svg": 56015,
	"./client/applications/justopp/assets/static/icons/justoppIcons/brands-stripe.svg": 18878,
	"./client/applications/justopp/assets/static/icons/justoppIcons/brands-twitter.svg": 96377,
	"./client/applications/justopp/assets/static/icons/justoppIcons/brands-youtube.svg": 94129,
	"./client/applications/justopp/assets/static/icons/justoppIcons/bug.svg": 56677,
	"./client/applications/justopp/assets/static/icons/justoppIcons/buyer-benefits.svg": 98258,
	"./client/applications/justopp/assets/static/icons/justoppIcons/calendar.svg": 23820,
	"./client/applications/justopp/assets/static/icons/justoppIcons/camera-alt.svg": 72496,
	"./client/applications/justopp/assets/static/icons/justoppIcons/camera.svg": 50471,
	"./client/applications/justopp/assets/static/icons/justoppIcons/cart-basket.svg": 95284,
	"./client/applications/justopp/assets/static/icons/justoppIcons/cart-plus.svg": 17214,
	"./client/applications/justopp/assets/static/icons/justoppIcons/cart.svg": 91028,
	"./client/applications/justopp/assets/static/icons/justoppIcons/cart2.svg": 90233,
	"./client/applications/justopp/assets/static/icons/justoppIcons/cassette.svg": 34375,
	"./client/applications/justopp/assets/static/icons/justoppIcons/chart-bar-alt.svg": 61444,
	"./client/applications/justopp/assets/static/icons/justoppIcons/chart-bar.svg": 38665,
	"./client/applications/justopp/assets/static/icons/justoppIcons/chart-intersect.svg": 53419,
	"./client/applications/justopp/assets/static/icons/justoppIcons/chart-line.svg": 61028,
	"./client/applications/justopp/assets/static/icons/justoppIcons/chart-pie.svg": 9747,
	"./client/applications/justopp/assets/static/icons/justoppIcons/chat-alt.svg": 21645,
	"./client/applications/justopp/assets/static/icons/justoppIcons/chat-incoming-alt.svg": 4441,
	"./client/applications/justopp/assets/static/icons/justoppIcons/chat-incoming.svg": 14614,
	"./client/applications/justopp/assets/static/icons/justoppIcons/chat-message-alt.svg": 54600,
	"./client/applications/justopp/assets/static/icons/justoppIcons/chat-message.svg": 20738,
	"./client/applications/justopp/assets/static/icons/justoppIcons/chat.svg": 21533,
	"./client/applications/justopp/assets/static/icons/justoppIcons/check-circle.svg": 2808,
	"./client/applications/justopp/assets/static/icons/justoppIcons/check-list.svg": 29625,
	"./client/applications/justopp/assets/static/icons/justoppIcons/check-square.svg": 98512,
	"./client/applications/justopp/assets/static/icons/justoppIcons/check.svg": 44895,
	"./client/applications/justopp/assets/static/icons/justoppIcons/chevron-down.svg": 61115,
	"./client/applications/justopp/assets/static/icons/justoppIcons/chevron-left.svg": 751,
	"./client/applications/justopp/assets/static/icons/justoppIcons/chevron-right.svg": 67812,
	"./client/applications/justopp/assets/static/icons/justoppIcons/chevron-up.svg": 16343,
	"./client/applications/justopp/assets/static/icons/justoppIcons/chevrons-down.svg": 28922,
	"./client/applications/justopp/assets/static/icons/justoppIcons/chevrons-left.svg": 43359,
	"./client/applications/justopp/assets/static/icons/justoppIcons/chevrons-right.svg": 54717,
	"./client/applications/justopp/assets/static/icons/justoppIcons/chevrons-up.svg": 77147,
	"./client/applications/justopp/assets/static/icons/justoppIcons/circle-fill.svg": 85447,
	"./client/applications/justopp/assets/static/icons/justoppIcons/circle-piece.svg": 70163,
	"./client/applications/justopp/assets/static/icons/justoppIcons/clipboard-check.svg": 58367,
	"./client/applications/justopp/assets/static/icons/justoppIcons/clipboard-x.svg": 67318,
	"./client/applications/justopp/assets/static/icons/justoppIcons/clipboard.svg": 36818,
	"./client/applications/justopp/assets/static/icons/justoppIcons/clock.svg": 56551,
	"./client/applications/justopp/assets/static/icons/justoppIcons/clone-reverse.svg": 28586,
	"./client/applications/justopp/assets/static/icons/justoppIcons/clone.svg": 91310,
	"./client/applications/justopp/assets/static/icons/justoppIcons/cloud-alt.svg": 30013,
	"./client/applications/justopp/assets/static/icons/justoppIcons/cloud-download.svg": 9284,
	"./client/applications/justopp/assets/static/icons/justoppIcons/cloud-rain.svg": 94066,
	"./client/applications/justopp/assets/static/icons/justoppIcons/cloud-upload.svg": 33127,
	"./client/applications/justopp/assets/static/icons/justoppIcons/cloud.svg": 36503,
	"./client/applications/justopp/assets/static/icons/justoppIcons/code-arrow-brackets.svg": 66647,
	"./client/applications/justopp/assets/static/icons/justoppIcons/code.svg": 11878,
	"./client/applications/justopp/assets/static/icons/justoppIcons/collapse.svg": 36566,
	"./client/applications/justopp/assets/static/icons/justoppIcons/color-palette.svg": 42825,
	"./client/applications/justopp/assets/static/icons/justoppIcons/command.svg": 60265,
	"./client/applications/justopp/assets/static/icons/justoppIcons/contrast.svg": 41594,
	"./client/applications/justopp/assets/static/icons/justoppIcons/copy-alt-reverse.svg": 91448,
	"./client/applications/justopp/assets/static/icons/justoppIcons/copy-alt.svg": 18581,
	"./client/applications/justopp/assets/static/icons/justoppIcons/copy-content-reverse.svg": 99170,
	"./client/applications/justopp/assets/static/icons/justoppIcons/copy-content.svg": 91554,
	"./client/applications/justopp/assets/static/icons/justoppIcons/copy-page-reverse.svg": 6230,
	"./client/applications/justopp/assets/static/icons/justoppIcons/copy-page.svg": 76989,
	"./client/applications/justopp/assets/static/icons/justoppIcons/copy-reverse.svg": 26057,
	"./client/applications/justopp/assets/static/icons/justoppIcons/copy.svg": 71252,
	"./client/applications/justopp/assets/static/icons/justoppIcons/create-profile.svg": 88142,
	"./client/applications/justopp/assets/static/icons/justoppIcons/credit-cards.svg": 57588,
	"./client/applications/justopp/assets/static/icons/justoppIcons/crop.svg": 48016,
	"./client/applications/justopp/assets/static/icons/justoppIcons/cube-multi.svg": 71509,
	"./client/applications/justopp/assets/static/icons/justoppIcons/cube.svg": 59011,
	"./client/applications/justopp/assets/static/icons/justoppIcons/dashboard.svg": 9120,
	"./client/applications/justopp/assets/static/icons/justoppIcons/degree.svg": 30433,
	"./client/applications/justopp/assets/static/icons/justoppIcons/down-arrow.svg": 31637,
	"./client/applications/justopp/assets/static/icons/justoppIcons/drop.svg": 53442,
	"./client/applications/justopp/assets/static/icons/justoppIcons/email.svg": 23474,
	"./client/applications/justopp/assets/static/icons/justoppIcons/explainer-bottom.svg": 47324,
	"./client/applications/justopp/assets/static/icons/justoppIcons/export.svg": 94367,
	"./client/applications/justopp/assets/static/icons/justoppIcons/eye-alt.svg": 65938,
	"./client/applications/justopp/assets/static/icons/justoppIcons/eye-hidden.svg": 9655,
	"./client/applications/justopp/assets/static/icons/justoppIcons/eye.svg": 7205,
	"./client/applications/justopp/assets/static/icons/justoppIcons/facebook.svg": 17213,
	"./client/applications/justopp/assets/static/icons/justoppIcons/file-copy.svg": 68946,
	"./client/applications/justopp/assets/static/icons/justoppIcons/file-zip.svg": 46866,
	"./client/applications/justopp/assets/static/icons/justoppIcons/file.svg": 96226,
	"./client/applications/justopp/assets/static/icons/justoppIcons/fire.svg": 39796,
	"./client/applications/justopp/assets/static/icons/justoppIcons/flag.svg": 3656,
	"./client/applications/justopp/assets/static/icons/justoppIcons/floppy-disk.svg": 15915,
	"./client/applications/justopp/assets/static/icons/justoppIcons/folder-copy.svg": 85205,
	"./client/applications/justopp/assets/static/icons/justoppIcons/folder-minus.svg": 89391,
	"./client/applications/justopp/assets/static/icons/justoppIcons/folder-open-alt.svg": 99668,
	"./client/applications/justopp/assets/static/icons/justoppIcons/folder-open.svg": 74824,
	"./client/applications/justopp/assets/static/icons/justoppIcons/folder-plus.svg": 95518,
	"./client/applications/justopp/assets/static/icons/justoppIcons/folder.svg": 33768,
	"./client/applications/justopp/assets/static/icons/justoppIcons/footer-chat.svg": 78057,
	"./client/applications/justopp/assets/static/icons/justoppIcons/footer-mail.svg": 59214,
	"./client/applications/justopp/assets/static/icons/justoppIcons/footer-video.svg": 81030,
	"./client/applications/justopp/assets/static/icons/justoppIcons/go-back.svg": 99942,
	"./client/applications/justopp/assets/static/icons/justoppIcons/go-forward.svg": 10479,
	"./client/applications/justopp/assets/static/icons/justoppIcons/grid-alt-reverse.svg": 99485,
	"./client/applications/justopp/assets/static/icons/justoppIcons/grid-alt.svg": 59360,
	"./client/applications/justopp/assets/static/icons/justoppIcons/grid-reverse.svg": 12233,
	"./client/applications/justopp/assets/static/icons/justoppIcons/grid.svg": 10794,
	"./client/applications/justopp/assets/static/icons/justoppIcons/handle-horizontal.svg": 33797,
	"./client/applications/justopp/assets/static/icons/justoppIcons/handle-vertical.svg": 81210,
	"./client/applications/justopp/assets/static/icons/justoppIcons/hard-drive.svg": 84791,
	"./client/applications/justopp/assets/static/icons/justoppIcons/hashtag.svg": 37564,
	"./client/applications/justopp/assets/static/icons/justoppIcons/headphones.svg": 61298,
	"./client/applications/justopp/assets/static/icons/justoppIcons/heart.svg": 94260,
	"./client/applications/justopp/assets/static/icons/justoppIcons/home-appliances.svg": 79955,
	"./client/applications/justopp/assets/static/icons/justoppIcons/home-entertainment.svg": 83684,
	"./client/applications/justopp/assets/static/icons/justoppIcons/hotspot-alt.svg": 11622,
	"./client/applications/justopp/assets/static/icons/justoppIcons/hotspot.svg": 20238,
	"./client/applications/justopp/assets/static/icons/justoppIcons/image.svg": 53063,
	"./client/applications/justopp/assets/static/icons/justoppIcons/import.svg": 96862,
	"./client/applications/justopp/assets/static/icons/justoppIcons/inbox-file.svg": 73132,
	"./client/applications/justopp/assets/static/icons/justoppIcons/inbox.svg": 84130,
	"./client/applications/justopp/assets/static/icons/justoppIcons/iphone.svg": 8132,
	"./client/applications/justopp/assets/static/icons/justoppIcons/it.svg": 60020,
	"./client/applications/justopp/assets/static/icons/justoppIcons/keyboard-hide.svg": 87329,
	"./client/applications/justopp/assets/static/icons/justoppIcons/keyboard.svg": 69497,
	"./client/applications/justopp/assets/static/icons/justoppIcons/kitchen-appliances.svg": 36391,
	"./client/applications/justopp/assets/static/icons/justoppIcons/laptop.svg": 88615,
	"./client/applications/justopp/assets/static/icons/justoppIcons/layer-stack.svg": 82291,
	"./client/applications/justopp/assets/static/icons/justoppIcons/life-float.svg": 81891,
	"./client/applications/justopp/assets/static/icons/justoppIcons/lightbulb.svg": 69455,
	"./client/applications/justopp/assets/static/icons/justoppIcons/link-alt.svg": 68071,
	"./client/applications/justopp/assets/static/icons/justoppIcons/link.svg": 64941,
	"./client/applications/justopp/assets/static/icons/justoppIcons/linkedin.svg": 84389,
	"./client/applications/justopp/assets/static/icons/justoppIcons/location.svg": 12950,
	"./client/applications/justopp/assets/static/icons/justoppIcons/lock-alt.svg": 59000,
	"./client/applications/justopp/assets/static/icons/justoppIcons/lock.svg": 76178,
	"./client/applications/justopp/assets/static/icons/justoppIcons/magnify-minus.svg": 52314,
	"./client/applications/justopp/assets/static/icons/justoppIcons/magnify-plus.svg": 31722,
	"./client/applications/justopp/assets/static/icons/justoppIcons/magnify.svg": 88621,
	"./client/applications/justopp/assets/static/icons/justoppIcons/mail-alt.svg": 61210,
	"./client/applications/justopp/assets/static/icons/justoppIcons/mail.svg": 69606,
	"./client/applications/justopp/assets/static/icons/justoppIcons/make-deal.svg": 58515,
	"./client/applications/justopp/assets/static/icons/justoppIcons/map-pin-location-alt.svg": 22767,
	"./client/applications/justopp/assets/static/icons/justoppIcons/map-pin-location.svg": 35252,
	"./client/applications/justopp/assets/static/icons/justoppIcons/map-pin.svg": 7046,
	"./client/applications/justopp/assets/static/icons/justoppIcons/map.svg": 48281,
	"./client/applications/justopp/assets/static/icons/justoppIcons/maximize.svg": 6680,
	"./client/applications/justopp/assets/static/icons/justoppIcons/mc-fast-forward.svg": 26853,
	"./client/applications/justopp/assets/static/icons/justoppIcons/mc-pause.svg": 6371,
	"./client/applications/justopp/assets/static/icons/justoppIcons/mc-play.svg": 95814,
	"./client/applications/justopp/assets/static/icons/justoppIcons/mc-repeat-all.svg": 46661,
	"./client/applications/justopp/assets/static/icons/justoppIcons/mc-repeat-one.svg": 31024,
	"./client/applications/justopp/assets/static/icons/justoppIcons/mc-repeat.svg": 59782,
	"./client/applications/justopp/assets/static/icons/justoppIcons/mc-shuffle.svg": 85898,
	"./client/applications/justopp/assets/static/icons/justoppIcons/mc-skip-back.svg": 38574,
	"./client/applications/justopp/assets/static/icons/justoppIcons/mc-skip.svg": 87606,
	"./client/applications/justopp/assets/static/icons/justoppIcons/mc-volume-off.svg": 71166,
	"./client/applications/justopp/assets/static/icons/justoppIcons/mc-volume.svg": 81054,
	"./client/applications/justopp/assets/static/icons/justoppIcons/menu-grid.svg": 685,
	"./client/applications/justopp/assets/static/icons/justoppIcons/mic-off.svg": 21551,
	"./client/applications/justopp/assets/static/icons/justoppIcons/mic.svg": 76225,
	"./client/applications/justopp/assets/static/icons/justoppIcons/minimize.svg": 41730,
	"./client/applications/justopp/assets/static/icons/justoppIcons/minus-circle.svg": 60336,
	"./client/applications/justopp/assets/static/icons/justoppIcons/minus-square.svg": 22430,
	"./client/applications/justopp/assets/static/icons/justoppIcons/minus.svg": 2446,
	"./client/applications/justopp/assets/static/icons/justoppIcons/mobile.svg": 41462,
	"./client/applications/justopp/assets/static/icons/justoppIcons/monitor.svg": 24413,
	"./client/applications/justopp/assets/static/icons/justoppIcons/moon.svg": 38566,
	"./client/applications/justopp/assets/static/icons/justoppIcons/mouse.svg": 75355,
	"./client/applications/justopp/assets/static/icons/justoppIcons/move.svg": 75394,
	"./client/applications/justopp/assets/static/icons/justoppIcons/paperclip-alt.svg": 92051,
	"./client/applications/justopp/assets/static/icons/justoppIcons/paperclip.svg": 56358,
	"./client/applications/justopp/assets/static/icons/justoppIcons/paragraph.svg": 32292,
	"./client/applications/justopp/assets/static/icons/justoppIcons/pen-tool.svg": 22415,
	"./client/applications/justopp/assets/static/icons/justoppIcons/pen.svg": 81787,
	"./client/applications/justopp/assets/static/icons/justoppIcons/pencil-draw.svg": 902,
	"./client/applications/justopp/assets/static/icons/justoppIcons/pencil-write.svg": 17775,
	"./client/applications/justopp/assets/static/icons/justoppIcons/pencil.svg": 1750,
	"./client/applications/justopp/assets/static/icons/justoppIcons/percent.svg": 14994,
	"./client/applications/justopp/assets/static/icons/justoppIcons/personal-care.svg": 89438,
	"./client/applications/justopp/assets/static/icons/justoppIcons/phone-hangup.svg": 39611,
	"./client/applications/justopp/assets/static/icons/justoppIcons/phone-receiving.svg": 15034,
	"./client/applications/justopp/assets/static/icons/justoppIcons/phone-ringing.svg": 44439,
	"./client/applications/justopp/assets/static/icons/justoppIcons/plus-circle.svg": 17396,
	"./client/applications/justopp/assets/static/icons/justoppIcons/plus-square.svg": 74832,
	"./client/applications/justopp/assets/static/icons/justoppIcons/plus.svg": 98401,
	"./client/applications/justopp/assets/static/icons/justoppIcons/print.svg": 79178,
	"./client/applications/justopp/assets/static/icons/justoppIcons/purchase-method.svg": 51366,
	"./client/applications/justopp/assets/static/icons/justoppIcons/qr-code.svg": 49147,
	"./client/applications/justopp/assets/static/icons/justoppIcons/question.svg": 77873,
	"./client/applications/justopp/assets/static/icons/justoppIcons/redo-alt.svg": 14960,
	"./client/applications/justopp/assets/static/icons/justoppIcons/redo.svg": 75691,
	"./client/applications/justopp/assets/static/icons/justoppIcons/refresh.svg": 18984,
	"./client/applications/justopp/assets/static/icons/justoppIcons/resize-alt-reverse.svg": 644,
	"./client/applications/justopp/assets/static/icons/justoppIcons/resize-alt.svg": 10924,
	"./client/applications/justopp/assets/static/icons/justoppIcons/resize-reverse.svg": 46769,
	"./client/applications/justopp/assets/static/icons/justoppIcons/resize.svg": 15192,
	"./client/applications/justopp/assets/static/icons/justoppIcons/rss.svg": 93157,
	"./client/applications/justopp/assets/static/icons/justoppIcons/scan.svg": 87172,
	"./client/applications/justopp/assets/static/icons/justoppIcons/search-deal.svg": 16529,
	"./client/applications/justopp/assets/static/icons/justoppIcons/search.svg": 40534,
	"./client/applications/justopp/assets/static/icons/justoppIcons/seller-benefits.svg": 46776,
	"./client/applications/justopp/assets/static/icons/justoppIcons/send-alt.svg": 41666,
	"./client/applications/justopp/assets/static/icons/justoppIcons/send.svg": 62323,
	"./client/applications/justopp/assets/static/icons/justoppIcons/server-alt.svg": 47205,
	"./client/applications/justopp/assets/static/icons/justoppIcons/server-cloud.svg": 46227,
	"./client/applications/justopp/assets/static/icons/justoppIcons/server.svg": 40777,
	"./client/applications/justopp/assets/static/icons/justoppIcons/settings.svg": 4788,
	"./client/applications/justopp/assets/static/icons/justoppIcons/shape-circle.svg": 3920,
	"./client/applications/justopp/assets/static/icons/justoppIcons/shape-square.svg": 34590,
	"./client/applications/justopp/assets/static/icons/justoppIcons/shape-triangle.svg": 22961,
	"./client/applications/justopp/assets/static/icons/justoppIcons/shapes.svg": 68647,
	"./client/applications/justopp/assets/static/icons/justoppIcons/share.svg": 75684,
	"./client/applications/justopp/assets/static/icons/justoppIcons/shield-check.svg": 86422,
	"./client/applications/justopp/assets/static/icons/justoppIcons/shield-hidden.svg": 42026,
	"./client/applications/justopp/assets/static/icons/justoppIcons/shield-x.svg": 87164,
	"./client/applications/justopp/assets/static/icons/justoppIcons/shield.svg": 96612,
	"./client/applications/justopp/assets/static/icons/justoppIcons/sliders-alt-horizontal.svg": 11231,
	"./client/applications/justopp/assets/static/icons/justoppIcons/sliders-alt-vertical.svg": 59676,
	"./client/applications/justopp/assets/static/icons/justoppIcons/sliders-horizontal.svg": 7776,
	"./client/applications/justopp/assets/static/icons/justoppIcons/sliders-vertical.svg": 67461,
	"./client/applications/justopp/assets/static/icons/justoppIcons/social-facebook.svg": 49592,
	"./client/applications/justopp/assets/static/icons/justoppIcons/speaker.svg": 76345,
	"./client/applications/justopp/assets/static/icons/justoppIcons/star-fill.svg": 60996,
	"./client/applications/justopp/assets/static/icons/justoppIcons/star.svg": 57192,
	"./client/applications/justopp/assets/static/icons/justoppIcons/stopwatch.svg": 53502,
	"./client/applications/justopp/assets/static/icons/justoppIcons/sun.svg": 79745,
	"./client/applications/justopp/assets/static/icons/justoppIcons/terminal-alt.svg": 20762,
	"./client/applications/justopp/assets/static/icons/justoppIcons/terminal.svg": 63405,
	"./client/applications/justopp/assets/static/icons/justoppIcons/thumbs-down.svg": 10320,
	"./client/applications/justopp/assets/static/icons/justoppIcons/thumbs-up.svg": 26467,
	"./client/applications/justopp/assets/static/icons/justoppIcons/trash-alt.svg": 90384,
	"./client/applications/justopp/assets/static/icons/justoppIcons/trash.svg": 18264,
	"./client/applications/justopp/assets/static/icons/justoppIcons/undo-alt.svg": 51261,
	"./client/applications/justopp/assets/static/icons/justoppIcons/undo.svg": 37308,
	"./client/applications/justopp/assets/static/icons/justoppIcons/unlock-alt.svg": 74020,
	"./client/applications/justopp/assets/static/icons/justoppIcons/unlock.svg": 40299,
	"./client/applications/justopp/assets/static/icons/justoppIcons/user-login.svg": 72740,
	"./client/applications/justopp/assets/static/icons/justoppIcons/user-minus-alt.svg": 98223,
	"./client/applications/justopp/assets/static/icons/justoppIcons/user-minus.svg": 23939,
	"./client/applications/justopp/assets/static/icons/justoppIcons/user-plus-alt.svg": 18454,
	"./client/applications/justopp/assets/static/icons/justoppIcons/user-plus.svg": 39917,
	"./client/applications/justopp/assets/static/icons/justoppIcons/user.svg": 83265,
	"./client/applications/justopp/assets/static/icons/justoppIcons/users.svg": 64584,
	"./client/applications/justopp/assets/static/icons/justoppIcons/video-off.svg": 82787,
	"./client/applications/justopp/assets/static/icons/justoppIcons/video.svg": 32737,
	"./client/applications/justopp/assets/static/icons/justoppIcons/voicemail.svg": 38056,
	"./client/applications/justopp/assets/static/icons/justoppIcons/wallet.svg": 37940,
	"./client/applications/justopp/assets/static/icons/justoppIcons/warning-circle.svg": 37355,
	"./client/applications/justopp/assets/static/icons/justoppIcons/warning-triangle.svg": 17004,
	"./client/applications/justopp/assets/static/icons/justoppIcons/watch.svg": 65644,
	"./client/applications/justopp/assets/static/icons/justoppIcons/wifi-disabled.svg": 21153,
	"./client/applications/justopp/assets/static/icons/justoppIcons/wifi.svg": 93302,
	"./client/applications/justopp/assets/static/icons/justoppIcons/x-circle.svg": 1987,
	"./client/applications/justopp/assets/static/icons/justoppIcons/x-square.svg": 25367,
	"./client/applications/justopp/assets/static/icons/justoppIcons/x.svg": 75946,
	"./client/assets/static/icons/a-test/test-icon.svg": 54955,
	"./client/assets/static/icons/rubicons/3d-scan.svg": 20315,
	"./client/assets/static/icons/rubicons/airplay.svg": 1684,
	"./client/assets/static/icons/rubicons/alarm.svg": 71441,
	"./client/assets/static/icons/rubicons/align-center-alt.svg": 18229,
	"./client/assets/static/icons/rubicons/align-center.svg": 80155,
	"./client/assets/static/icons/rubicons/align-justify-alt.svg": 72802,
	"./client/assets/static/icons/rubicons/align-justify.svg": 10027,
	"./client/assets/static/icons/rubicons/align-left-alt.svg": 7426,
	"./client/assets/static/icons/rubicons/align-left.svg": 6599,
	"./client/assets/static/icons/rubicons/align-right-alt.svg": 14021,
	"./client/assets/static/icons/rubicons/align-right.svg": 37021,
	"./client/assets/static/icons/rubicons/archive.svg": 32179,
	"./client/assets/static/icons/rubicons/arrow-down-circle.svg": 75955,
	"./client/assets/static/icons/rubicons/arrow-down-small.svg": 19231,
	"./client/assets/static/icons/rubicons/arrow-down-square.svg": 66317,
	"./client/assets/static/icons/rubicons/arrow-down.svg": 87610,
	"./client/assets/static/icons/rubicons/arrow-download-alt.svg": 92542,
	"./client/assets/static/icons/rubicons/arrow-download.svg": 20231,
	"./client/assets/static/icons/rubicons/arrow-left-circle.svg": 22304,
	"./client/assets/static/icons/rubicons/arrow-left-down.svg": 64336,
	"./client/assets/static/icons/rubicons/arrow-left-small.svg": 34694,
	"./client/assets/static/icons/rubicons/arrow-left-square.svg": 27244,
	"./client/assets/static/icons/rubicons/arrow-left-up.svg": 61305,
	"./client/assets/static/icons/rubicons/arrow-left.svg": 49004,
	"./client/assets/static/icons/rubicons/arrow-login-left-alt.svg": 94064,
	"./client/assets/static/icons/rubicons/arrow-login-left.svg": 89266,
	"./client/assets/static/icons/rubicons/arrow-login-right-alt.svg": 18414,
	"./client/assets/static/icons/rubicons/arrow-login-right.svg": 8270,
	"./client/assets/static/icons/rubicons/arrow-logout-left-alt.svg": 5785,
	"./client/assets/static/icons/rubicons/arrow-logout-left.svg": 66566,
	"./client/assets/static/icons/rubicons/arrow-logout-right-alt.svg": 7338,
	"./client/assets/static/icons/rubicons/arrow-logout-right.svg": 43569,
	"./client/assets/static/icons/rubicons/arrow-right-circle.svg": 741,
	"./client/assets/static/icons/rubicons/arrow-right-down.svg": 43062,
	"./client/assets/static/icons/rubicons/arrow-right-small.svg": 68803,
	"./client/assets/static/icons/rubicons/arrow-right-square.svg": 28234,
	"./client/assets/static/icons/rubicons/arrow-right-up.svg": 27114,
	"./client/assets/static/icons/rubicons/arrow-right.svg": 41952,
	"./client/assets/static/icons/rubicons/arrow-up-circle.svg": 19485,
	"./client/assets/static/icons/rubicons/arrow-up-small.svg": 44205,
	"./client/assets/static/icons/rubicons/arrow-up-square.svg": 70015,
	"./client/assets/static/icons/rubicons/arrow-up.svg": 74610,
	"./client/assets/static/icons/rubicons/arrow-upload-alt.svg": 4209,
	"./client/assets/static/icons/rubicons/arrow-upload.svg": 72271,
	"./client/assets/static/icons/rubicons/arrows-sort.svg": 19458,
	"./client/assets/static/icons/rubicons/article.svg": 47698,
	"./client/assets/static/icons/rubicons/bag-alt.svg": 28805,
	"./client/assets/static/icons/rubicons/bag-plus.svg": 80434,
	"./client/assets/static/icons/rubicons/bag.svg": 24173,
	"./client/assets/static/icons/rubicons/bar-code.svg": 73851,
	"./client/assets/static/icons/rubicons/basket.svg": 40594,
	"./client/assets/static/icons/rubicons/battery-charging.svg": 13864,
	"./client/assets/static/icons/rubicons/battery-empty.svg": 74296,
	"./client/assets/static/icons/rubicons/battery-full.svg": 92327,
	"./client/assets/static/icons/rubicons/battery-half.svg": 7152,
	"./client/assets/static/icons/rubicons/bell.svg": 28726,
	"./client/assets/static/icons/rubicons/binder.svg": 58971,
	"./client/assets/static/icons/rubicons/bluetooth.svg": 42118,
	"./client/assets/static/icons/rubicons/book.svg": 24162,
	"./client/assets/static/icons/rubicons/bookmark.svg": 20453,
	"./client/assets/static/icons/rubicons/brands-codepen.svg": 64051,
	"./client/assets/static/icons/rubicons/brands-codesandbox.svg": 61263,
	"./client/assets/static/icons/rubicons/brands-dribbble.svg": 47867,
	"./client/assets/static/icons/rubicons/brands-dropbox.svg": 4941,
	"./client/assets/static/icons/rubicons/brands-facebook.svg": 14765,
	"./client/assets/static/icons/rubicons/brands-figma.svg": 40654,
	"./client/assets/static/icons/rubicons/brands-github.svg": 88492,
	"./client/assets/static/icons/rubicons/brands-google.svg": 4854,
	"./client/assets/static/icons/rubicons/brands-instagram.svg": 29473,
	"./client/assets/static/icons/rubicons/brands-linkedin.svg": 24588,
	"./client/assets/static/icons/rubicons/brands-paypal.svg": 92353,
	"./client/assets/static/icons/rubicons/brands-snapchat.svg": 68523,
	"./client/assets/static/icons/rubicons/brands-stripe.svg": 95810,
	"./client/assets/static/icons/rubicons/brands-twitter.svg": 73456,
	"./client/assets/static/icons/rubicons/brands-youtube.svg": 7848,
	"./client/assets/static/icons/rubicons/bug.svg": 43650,
	"./client/assets/static/icons/rubicons/calendar.svg": 11307,
	"./client/assets/static/icons/rubicons/camera-alt.svg": 70623,
	"./client/assets/static/icons/rubicons/camera.svg": 24502,
	"./client/assets/static/icons/rubicons/cart-basket.svg": 41170,
	"./client/assets/static/icons/rubicons/cart-plus.svg": 12938,
	"./client/assets/static/icons/rubicons/cart.svg": 9703,
	"./client/assets/static/icons/rubicons/cassette.svg": 11269,
	"./client/assets/static/icons/rubicons/chart-bar-alt.svg": 32578,
	"./client/assets/static/icons/rubicons/chart-bar.svg": 72034,
	"./client/assets/static/icons/rubicons/chart-intersect.svg": 92279,
	"./client/assets/static/icons/rubicons/chart-line.svg": 60159,
	"./client/assets/static/icons/rubicons/chart-pie.svg": 16174,
	"./client/assets/static/icons/rubicons/chat-alt.svg": 86537,
	"./client/assets/static/icons/rubicons/chat-incoming-alt.svg": 79870,
	"./client/assets/static/icons/rubicons/chat-incoming.svg": 72822,
	"./client/assets/static/icons/rubicons/chat-message-alt.svg": 45301,
	"./client/assets/static/icons/rubicons/chat-message.svg": 36053,
	"./client/assets/static/icons/rubicons/chat.svg": 87932,
	"./client/assets/static/icons/rubicons/check-circle.svg": 2222,
	"./client/assets/static/icons/rubicons/check-list.svg": 6151,
	"./client/assets/static/icons/rubicons/check-square.svg": 51684,
	"./client/assets/static/icons/rubicons/check.svg": 65186,
	"./client/assets/static/icons/rubicons/chevron-down.svg": 88442,
	"./client/assets/static/icons/rubicons/chevron-left.svg": 52891,
	"./client/assets/static/icons/rubicons/chevron-right.svg": 11618,
	"./client/assets/static/icons/rubicons/chevron-up.svg": 17820,
	"./client/assets/static/icons/rubicons/chevrons-down.svg": 76222,
	"./client/assets/static/icons/rubicons/chevrons-left.svg": 68655,
	"./client/assets/static/icons/rubicons/chevrons-right.svg": 52636,
	"./client/assets/static/icons/rubicons/chevrons-up.svg": 96142,
	"./client/assets/static/icons/rubicons/circle-fill.svg": 69549,
	"./client/assets/static/icons/rubicons/circle-piece.svg": 76661,
	"./client/assets/static/icons/rubicons/clipboard-check.svg": 53730,
	"./client/assets/static/icons/rubicons/clipboard-x.svg": 52556,
	"./client/assets/static/icons/rubicons/clipboard.svg": 8040,
	"./client/assets/static/icons/rubicons/clock.svg": 32426,
	"./client/assets/static/icons/rubicons/clone-reverse.svg": 39077,
	"./client/assets/static/icons/rubicons/clone.svg": 19933,
	"./client/assets/static/icons/rubicons/cloud-alt.svg": 98605,
	"./client/assets/static/icons/rubicons/cloud-download.svg": 18990,
	"./client/assets/static/icons/rubicons/cloud-rain.svg": 87497,
	"./client/assets/static/icons/rubicons/cloud-upload.svg": 44379,
	"./client/assets/static/icons/rubicons/cloud.svg": 51686,
	"./client/assets/static/icons/rubicons/code-arrow-brackets.svg": 75498,
	"./client/assets/static/icons/rubicons/code.svg": 28870,
	"./client/assets/static/icons/rubicons/collapse.svg": 18104,
	"./client/assets/static/icons/rubicons/color-palette.svg": 12954,
	"./client/assets/static/icons/rubicons/command.svg": 17491,
	"./client/assets/static/icons/rubicons/contrast.svg": 24892,
	"./client/assets/static/icons/rubicons/copy-alt-reverse.svg": 43059,
	"./client/assets/static/icons/rubicons/copy-alt.svg": 71618,
	"./client/assets/static/icons/rubicons/copy-content-reverse.svg": 81923,
	"./client/assets/static/icons/rubicons/copy-content.svg": 94568,
	"./client/assets/static/icons/rubicons/copy-page-reverse.svg": 76317,
	"./client/assets/static/icons/rubicons/copy-page.svg": 83842,
	"./client/assets/static/icons/rubicons/copy-reverse.svg": 20273,
	"./client/assets/static/icons/rubicons/copy.svg": 58856,
	"./client/assets/static/icons/rubicons/credit-cards.svg": 44688,
	"./client/assets/static/icons/rubicons/crop.svg": 90312,
	"./client/assets/static/icons/rubicons/cube-multi.svg": 93184,
	"./client/assets/static/icons/rubicons/cube.svg": 52894,
	"./client/assets/static/icons/rubicons/dashboard.svg": 87923,
	"./client/assets/static/icons/rubicons/degree.svg": 3496,
	"./client/assets/static/icons/rubicons/drop.svg": 31276,
	"./client/assets/static/icons/rubicons/email.svg": 87833,
	"./client/assets/static/icons/rubicons/export.svg": 42471,
	"./client/assets/static/icons/rubicons/eye-alt.svg": 93033,
	"./client/assets/static/icons/rubicons/eye-hidden.svg": 26515,
	"./client/assets/static/icons/rubicons/eye.svg": 8718,
	"./client/assets/static/icons/rubicons/file-copy.svg": 42889,
	"./client/assets/static/icons/rubicons/file-zip.svg": 36958,
	"./client/assets/static/icons/rubicons/file.svg": 50795,
	"./client/assets/static/icons/rubicons/fire.svg": 39452,
	"./client/assets/static/icons/rubicons/flag.svg": 15962,
	"./client/assets/static/icons/rubicons/floppy-disk.svg": 89659,
	"./client/assets/static/icons/rubicons/folder-copy.svg": 95339,
	"./client/assets/static/icons/rubicons/folder-minus.svg": 78673,
	"./client/assets/static/icons/rubicons/folder-open-alt.svg": 11370,
	"./client/assets/static/icons/rubicons/folder-open.svg": 64334,
	"./client/assets/static/icons/rubicons/folder-plus.svg": 229,
	"./client/assets/static/icons/rubicons/folder.svg": 9680,
	"./client/assets/static/icons/rubicons/go-back.svg": 147,
	"./client/assets/static/icons/rubicons/go-forward.svg": 61691,
	"./client/assets/static/icons/rubicons/grid-alt-reverse.svg": 40736,
	"./client/assets/static/icons/rubicons/grid-alt.svg": 73130,
	"./client/assets/static/icons/rubicons/grid-reverse.svg": 83478,
	"./client/assets/static/icons/rubicons/grid.svg": 23113,
	"./client/assets/static/icons/rubicons/handle-horizontal.svg": 94001,
	"./client/assets/static/icons/rubicons/handle-vertical.svg": 38363,
	"./client/assets/static/icons/rubicons/hard-drive.svg": 93268,
	"./client/assets/static/icons/rubicons/hashtag.svg": 9892,
	"./client/assets/static/icons/rubicons/headphones.svg": 74785,
	"./client/assets/static/icons/rubicons/heart.svg": 26617,
	"./client/assets/static/icons/rubicons/home.svg": 64789,
	"./client/assets/static/icons/rubicons/hotspot-alt.svg": 35843,
	"./client/assets/static/icons/rubicons/hotspot.svg": 67595,
	"./client/assets/static/icons/rubicons/image.svg": 77329,
	"./client/assets/static/icons/rubicons/import.svg": 2407,
	"./client/assets/static/icons/rubicons/inbox-file.svg": 42282,
	"./client/assets/static/icons/rubicons/inbox.svg": 1919,
	"./client/assets/static/icons/rubicons/info.svg": 29012,
	"./client/assets/static/icons/rubicons/iphone.svg": 56028,
	"./client/assets/static/icons/rubicons/keyboard-hide.svg": 64932,
	"./client/assets/static/icons/rubicons/keyboard.svg": 82869,
	"./client/assets/static/icons/rubicons/language.svg": 63829,
	"./client/assets/static/icons/rubicons/laptop.svg": 88982,
	"./client/assets/static/icons/rubicons/layer-stack.svg": 80449,
	"./client/assets/static/icons/rubicons/life-float.svg": 40617,
	"./client/assets/static/icons/rubicons/lightbulb.svg": 41016,
	"./client/assets/static/icons/rubicons/link-alt.svg": 26865,
	"./client/assets/static/icons/rubicons/link.svg": 22957,
	"./client/assets/static/icons/rubicons/location.svg": 88168,
	"./client/assets/static/icons/rubicons/lock-alt.svg": 49269,
	"./client/assets/static/icons/rubicons/lock.svg": 36270,
	"./client/assets/static/icons/rubicons/magnify-minus.svg": 62640,
	"./client/assets/static/icons/rubicons/magnify-plus.svg": 55001,
	"./client/assets/static/icons/rubicons/magnify.svg": 98980,
	"./client/assets/static/icons/rubicons/mail-alt.svg": 81282,
	"./client/assets/static/icons/rubicons/mail.svg": 54126,
	"./client/assets/static/icons/rubicons/map-pin-location-alt.svg": 84174,
	"./client/assets/static/icons/rubicons/map-pin-location.svg": 24733,
	"./client/assets/static/icons/rubicons/map-pin.svg": 40591,
	"./client/assets/static/icons/rubicons/map.svg": 95797,
	"./client/assets/static/icons/rubicons/maximize.svg": 9615,
	"./client/assets/static/icons/rubicons/mc-fast-forward.svg": 80572,
	"./client/assets/static/icons/rubicons/mc-pause.svg": 80538,
	"./client/assets/static/icons/rubicons/mc-play.svg": 27513,
	"./client/assets/static/icons/rubicons/mc-repeat-all.svg": 22530,
	"./client/assets/static/icons/rubicons/mc-repeat-one.svg": 80,
	"./client/assets/static/icons/rubicons/mc-repeat.svg": 69143,
	"./client/assets/static/icons/rubicons/mc-shuffle.svg": 60320,
	"./client/assets/static/icons/rubicons/mc-skip-back.svg": 13808,
	"./client/assets/static/icons/rubicons/mc-skip.svg": 14326,
	"./client/assets/static/icons/rubicons/mc-volume-off.svg": 33659,
	"./client/assets/static/icons/rubicons/mc-volume.svg": 37647,
	"./client/assets/static/icons/rubicons/menu-grid.svg": 90267,
	"./client/assets/static/icons/rubicons/mic-off.svg": 90797,
	"./client/assets/static/icons/rubicons/mic.svg": 52787,
	"./client/assets/static/icons/rubicons/minimize.svg": 24940,
	"./client/assets/static/icons/rubicons/minus-circle.svg": 85797,
	"./client/assets/static/icons/rubicons/minus-square.svg": 52441,
	"./client/assets/static/icons/rubicons/minus.svg": 7261,
	"./client/assets/static/icons/rubicons/monitor.svg": 23133,
	"./client/assets/static/icons/rubicons/moon.svg": 5738,
	"./client/assets/static/icons/rubicons/mouse.svg": 50402,
	"./client/assets/static/icons/rubicons/move.svg": 43385,
	"./client/assets/static/icons/rubicons/paperclip-alt.svg": 36126,
	"./client/assets/static/icons/rubicons/paperclip.svg": 44001,
	"./client/assets/static/icons/rubicons/paragraph.svg": 71513,
	"./client/assets/static/icons/rubicons/pen-tool.svg": 99155,
	"./client/assets/static/icons/rubicons/pen.svg": 82114,
	"./client/assets/static/icons/rubicons/pencil-draw.svg": 71080,
	"./client/assets/static/icons/rubicons/pencil-write.svg": 18390,
	"./client/assets/static/icons/rubicons/pencil.svg": 78089,
	"./client/assets/static/icons/rubicons/percent.svg": 73115,
	"./client/assets/static/icons/rubicons/phone-hangup.svg": 91804,
	"./client/assets/static/icons/rubicons/phone-receiving.svg": 11338,
	"./client/assets/static/icons/rubicons/phone-ringing.svg": 95896,
	"./client/assets/static/icons/rubicons/plus-circle.svg": 50598,
	"./client/assets/static/icons/rubicons/plus-square.svg": 65482,
	"./client/assets/static/icons/rubicons/plus.svg": 74535,
	"./client/assets/static/icons/rubicons/print.svg": 32587,
	"./client/assets/static/icons/rubicons/qr-code.svg": 33763,
	"./client/assets/static/icons/rubicons/question.svg": 56300,
	"./client/assets/static/icons/rubicons/redo-alt.svg": 31321,
	"./client/assets/static/icons/rubicons/redo.svg": 17590,
	"./client/assets/static/icons/rubicons/refresh.svg": 14666,
	"./client/assets/static/icons/rubicons/resize-alt-reverse.svg": 66679,
	"./client/assets/static/icons/rubicons/resize-alt.svg": 43004,
	"./client/assets/static/icons/rubicons/resize-reverse.svg": 38403,
	"./client/assets/static/icons/rubicons/resize.svg": 50751,
	"./client/assets/static/icons/rubicons/rss.svg": 25990,
	"./client/assets/static/icons/rubicons/scan.svg": 37778,
	"./client/assets/static/icons/rubicons/send-alt.svg": 58923,
	"./client/assets/static/icons/rubicons/send.svg": 62236,
	"./client/assets/static/icons/rubicons/server-alt.svg": 37643,
	"./client/assets/static/icons/rubicons/server-cloud.svg": 31204,
	"./client/assets/static/icons/rubicons/server.svg": 82197,
	"./client/assets/static/icons/rubicons/settings.svg": 8024,
	"./client/assets/static/icons/rubicons/shape-circle.svg": 40127,
	"./client/assets/static/icons/rubicons/shape-square.svg": 10058,
	"./client/assets/static/icons/rubicons/shape-triangle.svg": 14393,
	"./client/assets/static/icons/rubicons/shapes.svg": 9097,
	"./client/assets/static/icons/rubicons/share.svg": 63382,
	"./client/assets/static/icons/rubicons/shield-check.svg": 94819,
	"./client/assets/static/icons/rubicons/shield-hidden.svg": 79343,
	"./client/assets/static/icons/rubicons/shield-x.svg": 14207,
	"./client/assets/static/icons/rubicons/shield.svg": 23788,
	"./client/assets/static/icons/rubicons/sliders-alt-horizontal.svg": 92895,
	"./client/assets/static/icons/rubicons/sliders-alt-vertical.svg": 71577,
	"./client/assets/static/icons/rubicons/sliders-horizontal.svg": 69448,
	"./client/assets/static/icons/rubicons/sliders-vertical.svg": 69801,
	"./client/assets/static/icons/rubicons/social-facebook.svg": 32751,
	"./client/assets/static/icons/rubicons/speaker.svg": 50790,
	"./client/assets/static/icons/rubicons/star-fill.svg": 83332,
	"./client/assets/static/icons/rubicons/star.svg": 94037,
	"./client/assets/static/icons/rubicons/stopwatch.svg": 43122,
	"./client/assets/static/icons/rubicons/sun.svg": 10829,
	"./client/assets/static/icons/rubicons/terminal-alt.svg": 63698,
	"./client/assets/static/icons/rubicons/terminal.svg": 72175,
	"./client/assets/static/icons/rubicons/thumbs-down.svg": 83295,
	"./client/assets/static/icons/rubicons/thumbs-up.svg": 13374,
	"./client/assets/static/icons/rubicons/trash-alt.svg": 67798,
	"./client/assets/static/icons/rubicons/trash.svg": 9748,
	"./client/assets/static/icons/rubicons/undo-alt.svg": 35607,
	"./client/assets/static/icons/rubicons/undo.svg": 70737,
	"./client/assets/static/icons/rubicons/unlock-alt.svg": 27079,
	"./client/assets/static/icons/rubicons/unlock.svg": 14605,
	"./client/assets/static/icons/rubicons/user-minus-alt.svg": 44888,
	"./client/assets/static/icons/rubicons/user-minus.svg": 61969,
	"./client/assets/static/icons/rubicons/user-plus-alt.svg": 68878,
	"./client/assets/static/icons/rubicons/user-plus.svg": 98124,
	"./client/assets/static/icons/rubicons/user.svg": 26229,
	"./client/assets/static/icons/rubicons/users.svg": 53151,
	"./client/assets/static/icons/rubicons/video-off.svg": 50527,
	"./client/assets/static/icons/rubicons/video.svg": 86708,
	"./client/assets/static/icons/rubicons/voicemail.svg": 4959,
	"./client/assets/static/icons/rubicons/wallet.svg": 59449,
	"./client/assets/static/icons/rubicons/warning-circle.svg": 10890,
	"./client/assets/static/icons/rubicons/warning-triangle.svg": 46358,
	"./client/assets/static/icons/rubicons/watch.svg": 95204,
	"./client/assets/static/icons/rubicons/wifi-disabled.svg": 83833,
	"./client/assets/static/icons/rubicons/wifi.svg": 33682,
	"./client/assets/static/icons/rubicons/x-circle.svg": 75756,
	"./client/assets/static/icons/rubicons/x-square.svg": 72482,
	"./client/assets/static/icons/rubicons/x.svg": 4712
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 33141;